import IssueList from '@/components/linear/issue-list';
import PageToolbar from '@/components/linear/page-toolbar';
import TeamIcon from '@/components/linear/team-icon';
import { issueQueryView, setIssueQueryView } from '@/lib/issue-query';
import { openIssuePath, teamPath } from '@/lib/linear-paths';
import type { Issue, IssueView } from '@/types/issue';
import type { Team } from '@/types/team';
import { router } from '@inertiajs/react';

interface Props {
  team: Team;
  issues?: Issue[];
  view?: IssueView;
  q?: string;
}

export default function Show({ team, issues = [], view, q = '' }: Props) {
  const currentView = view ?? issueQueryView(q);

  const setView = (next: IssueView) => {
    router.get(
      teamPath(team.id),
      { q: setIssueQueryView(q, next) || undefined },
      { preserveState: true, preserveScroll: true }
    );
  };

  return (
    <div className="ln-page">
      <PageToolbar
        title={team.name}
        tabs={
          <div className="ln-tabs">
            <span
              className="ln-toolbar-title"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
            >
              <TeamIcon color={team.color} />
              {team.key}
            </span>
            <button
              type="button"
              className="ln-tab"
              data-active={currentView === 'all' ? 'true' : 'false'}
              onClick={() => setView('all')}
            >
              All issues
            </button>
            <button
              type="button"
              className="ln-tab"
              data-active={currentView === 'active' ? 'true' : 'false'}
              onClick={() => setView('active')}
            >
              Active
            </button>
            <button
              type="button"
              className="ln-tab"
              data-active={currentView === 'backlog' ? 'true' : 'false'}
              onClick={() => setView('backlog')}
            >
              Backlog
            </button>
          </div>
        }
      />
      <div className="ln-page-scroll">
        <IssueList issues={issues} onSelect={(issue) => router.visit(openIssuePath(issue))} />
      </div>
    </div>
  );
}
